<template lang="pug">

    .ui.secondary.pointing.menu
        //- Variante
        router-link.item(
            v-for='variant in variants'
            v-bind:key='variant.id'
            v-bind:to='{ name: $route.name, params: { id: variant.product, variantId: variant.id }}'
        ) Variante {{ variant.number }}

        //- Variante kopieren
        a.item(v-if='variants.length < 5 && $route.name !== "quality-rating"' v-on:click="copy()") Variant kopieren

        //- "Variante kopieren"-Modal
        modal(ref="modal")

            //- Header
            span(slot="header") Variant kopieren

            //- Content/Form
            form.ui.form(slot="content")

                .segment
                    printings-form(
                        v-model="model"
                    )

                .segment
                    variant-form(
                        v-bind:form-model='formModel'
                        v-model='model'
                    )

            //- Actions
            action-row(
                slot="footer"
                v-on:cancel="cancel()"
                v-on:save="persist(model)"
            )

</template>

<script>
    import {
        collection_to_object as field_collection_to_object,
        object_to_collection as field_object_to_collection
    } from '@/utils/field'
    import ActionRow from '@/components/form/ActionRow'
    import Modal from '@/components/app/Modal'
    import PrintingsForm from './forms/PrintingsForm'
    import VariantForm from './forms/VariantForm'

    export default {

        components: { ActionRow, PrintingsForm, Modal, VariantForm },

        created() {
            this.updateModel()
        },

        data() {
            return {
                model: {}
            }
        },

        methods: {

            cancel() {
                this.$refs.modal.close()
            },

            copy() {
                this.$refs.modal.show()
            },

            async persist() {
                // Auflagen und Formularfelder/Produktspezifikationen in Format bringen
                const model = {
                    ...this.model,
                    fields: field_object_to_collection(this.model.fields),
                    printings: [
                        this.model.printing1,
                        this.model.printing2,
                        this.model.printing3,
                        this.model.printing4,
                        this.model.printing5,
                    ]
                }

                // Speichern
                const { id } = await this.$store.dispatch('variants/create', { productId: this.product.id, model })

                // Modal closen
                this.$refs.modal.close()

                // Erstellte Variant anzeigen
                this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id, variantId: id } })
            },

            updateModel() {
                const model = { ...this.activeVariant }

                // Auflagen in Format bringen
                const printings = this.activeVariant.printings
                model.printing1 = printings[0]
                model.printing2 = printings[1]
                model.printing3 = printings[2]
                model.printing4 = printings[3]
                model.printing5 = printings[4]

                // Felder in Format bringen
                model.fields = field_collection_to_object(this.fieldModels)

                this.model = model
            }
        },

        props: {

            activeVariant: {
                type: Object,
                required: true
            },

            fieldModels: {
                type: Array,
                required: true
            },

            formModel: {
                type: Object,
                required: true
            },

            product: {
                type: Object,
                required: true
            },

            variants: {
                type: Array,
                required: true
            }

        },

        watch: {
            activeVariant() {
                this.updateModel()
            }
        }

    }

</script>

<style scoped>

    .segment:not(:last-child) {
        padding-bottom: 1.5rem;
    }

</style>
